var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { ToolbarWithBackButton } from '../common/Toolbar';
import { Body } from '../root/PageRouter';
import { Grid, Tile, TileHeader, TileComment } from '../common/Tile';
import { useRouter } from '../../context/router-context';
export default function AdminHome() {
    var goForwardClick = useRouter().goForwardClick;
    return (_jsxs(_Fragment, { children: [_jsx(ToolbarWithBackButton, { children: "Platform Admin" }, void 0),
            _jsx(Body, { children: _jsxs(Grid, { children: [_jsxs(Tile, __assign({ onClick: goForwardClick('/admin/users') }, { children: [_jsx(TileHeader, { children: "Users and Access" }, void 0),
                                _jsx(TileComment, { children: "Manage users, roles and access to the platform." }, void 0)] }), void 0),
                        _jsxs(Tile, { children: [_jsx(TileHeader, { children: "Companies" }, void 0),
                                _jsx(TileComment, { children: "Manage companies on the platform." }, void 0)] }, void 0),
                        _jsxs(Tile, __assign({ onClick: function () {
                                // tslint:disable-next-line: no-object-mutation
                                window.location.pathname = '/graphql';
                            } }, { children: [_jsx(TileHeader, { children: "GraphQL" }, void 0),
                                _jsx(TileComment, { children: "GraphQL explorer of the back-end API and data (right now only works in local dev mode)." }, void 0)] }), void 0)] }, void 0) }, void 0)] }, void 0));
}
//# sourceMappingURL=AdminHome.js.map